module.exports = __webpack_public_path__ + "media/contract/Contract-4-2907b88e.jpeg";